import { isExtensions } from "./index";
/**
 * Returns whether obj matches the Property interface
 * @param obj
 */
export function isProperty(obj) {
    if (obj === null)
        return false;
    if (typeof obj !== "object")
        return false;
    if (obj.maximum !== undefined && obj.maximum !== null && typeof obj.maximum !== "number")
        return false;
    if (obj.minimum !== undefined && obj.minimum !== null && typeof obj.minimum !== "number")
        return false;
    if (typeof obj.extensions !== "undefined" && obj.extensions !== null) {
        if (!isExtensions(obj.extensions))
            return false;
    }
    return true;
}
